<!-- Nested tree -->
<app-tree-group
  [theme]="theme"
  [graph]="searchGraph ? searchGraph : viewGraph$ | async">
</app-tree-group>